import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import i18n from "i18next";

export const Route = createFileRoute("/_auth")({
  beforeLoad: ({ context }) => {
    if (context.auth.session) {
      throw redirect({ to: "/", replace: true });
    }
  },
  head: () => ({ meta: [{ title: i18n.t("general:documentTitle.login") }] }),
  component: Outlet,
});
